import script from "./ArgonTableSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonTableSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__